<template>
  <v-dialog v-model="dialog" width="600" persistent v-if="dialog">
    <v-card>
      <v-toolbar max-height="64" class="mb-2">
        <v-toolbar-title>
          {{ $t("deposit") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="px-6">
        <div v-if="paymentStarted === false">
          <div class="pa-2 px-6 d-flex flex-column">
            <span>{{ $t("name") }}: {{ userName }}</span>
            <span>{{ $t("value") }}: R$ {{ value }}</span>
          </div>
          <div class="mb-6">
            <v-subheader class="overline mt-2">
              {{ $t("attention") }}
            </v-subheader>
            <div class="px-4">
              {{ description }}
            </div>
          </div>
        </div>
        <div class="mb-6" v-else>
          <v-subheader class="overline mt-2 ">
            QR Code
          </v-subheader>
          <div class="px-4">
            <v-img
              :src="qrCode"
              max-height="200px"
              max-width="200px"
              class="my-0 mx-auto"
              style="background: white !important;"
            />
          </div>
          <v-subheader class="overline mt-2">
            <p class="font-weight-bold">{{ $t("code") }} PIX</p>
          </v-subheader>
          <div class="mx-8">
            <v-btn block @click="$copy(pixCode)" color="primary" class="mb-4">
              <v-icon small left>mdi-content-copy</v-icon>
              {{ $t("copyCode") }}
            </v-btn>
          </div>
          <div class="pt-8">
            {{ $t("depositForPlayerPixDescription", { value }) }}
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog">
          {{ $t("toCancel") }}
        </v-btn>
        <v-btn
          color="primary"
          @click="submit"
          :loading="depositLoading"
          :disabled="depositLoading || paymentStarted"
        >
          {{ $t("toConfirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["dialog", "userName", "pix", "value", "paybrokersV4", "depositType"],
  data: () => ({
    qrCode: "",
    pixCode: "",
    paymentStarted: false,
    depositLoading: false,
  }),
  computed: {
    description() {
      return this.depositType === "pix" || this.depositType === "paag"
        ? this.$t("depositForPlayerPixDescription", { value: this.value })
        : this.$t("depositForPlayerManualDescription", { value: this.value });
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.paymentStarted = false;
      }
    },
  },
  methods: {
    async copyPixCode() {
      await navigator.clipboard.writeText(this.pixCode);
    },
    submit() {
      if (["betclub7", "viapix"].includes(localStorage.getItem("operator"))) {
        return;
      }

      this.depositLoading = true;

      if (this.depositType === "pix") {
        this.pixDepositForPlayer();
      } else if (this.depositType === "paag") {
        this.paagDepositForPlayer();
      } else {
        this.manualDepositForPlayer();
      }
    },
    paagDepositForPlayer() {
      const body = {
        id_user: this.$store.state.filters.autocompletePlayers.id,
        value: this.value,
      };

      this.$axios
        .post(
          "/administrator/payments/paag/depositForPlayerPaag",
          this.$formdata(body)
        )
        .then((res) => {
          this.qrCode = res.data.link_billet;
          this.pixCode = res.data.code;
          this.paymentStarted = true;
        })
        .finally(() => {
          this.depositLoading = false;
          // this.$emit("resetFields");
        });
    },
    manualDepositForPlayer() {
      const body = {
        id_player: this.$store.state.filters.autocompletePlayers.id,
        value: this.value,
      };

      this.$axios
        .post(
          "/administrator/bankOnline/depositDetachedOnline",
          this.$formdata(body)
        )
        .then((res) => {
          this.$store.commit("setFeedbackSnack", {
            msg: res.data.messages,
            color: "success",
          });
        })
        .finally(() => {
          this.depositLoading = false;
          this.$emit("resetFields");
          this.closeDialog();
        });
    },
    pixDepositForPlayer() {
      const body = {
        id_user: this.$store.state.filters.autocompletePlayers.id,
        value: this.value,
      };

      let endpoint = "/administrator/bankOnline/depositForPlayer";

      if (this.paybrokersV4) {
        endpoint = "/administrator/bankOnline/depositForPlayerPaybrokersV4";
      }

      this.$axios
        .post(endpoint, this.$formdata(body))
        .then((res) => {
          this.qrCode = res.data.link_billet;
          this.pixCode = res.data.code;
          this.paymentStarted = true;
        })
        .finally(() => {
          this.depositLoading = false;
          // this.$emit("resetFields");
        });
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>
